<template>
  <div class="busWrap">
    <component :is='tabItem' :height='height' :width='width'></component>
  </div>
</template>

<script>
import grain from '../grain/grain'
import water from '../grain/water'
import setMac from '../grain/setMac'
import fixed from '../grain/fixed'
import pointLine from '../grain/pointLine'
import gather from '../grain/gather'
import gatherWater from '../grain/gatherWater'
import history from '../grain/history'
import upTemp from '../grain/upTemp'
import gasConfig from '../gasTest/gasConfig'
import gasTest from '../gasTest/gasTest'
import manualOperation from '../circulation/manualOperation'
import cirAI from '../circulation/cirAI'
import cirSetTask from '../circulation/cirSetTask'
import cirHistory from '../circulation/cirHistory'
import cirConfig from '../circulation/cirConfig'
import cirFanConfig from '../circulation/cirFanConfig'
import oilWareConfig from '../oilSituation/oilWareConfig'
import oilHistory from '../oilSituation/oilHistory'
import n2History from '../nitrogenAdjust/n2History'
import gasHistory from '../nitrogenAdjust/gasHistory'
import airHistory from '../airCondItioner/airHistory'
export default {
  props:{
    width:Number,
    height:Number,
    log:''
  },
  components:{
    grain,
    water,
    setMac,
    fixed,
    gather,
    gatherWater,
    pointLine,
    history,
    upTemp,
    gasTest,
    gasConfig,
    manualOperation,
    cirAI,
    cirSetTask,
    cirHistory,
    cirConfig,
    cirFanConfig,
    oilWareConfig,
    oilHistory,
    n2History,
    gasHistory,
    airHistory
  },
  data(){
    return{
      tabItem:''
    }
  },
  watch: {
    log(newV, oldV) {
      this.tabItem=newV
    }
  },
  created(){
    this.tabItem=this.log
  }
}
</script>

<style>
  .busWrap{
    height: 100%;
    width: 100%;
    position: relative;
  }
</style>
